module.exports = __webpack_public_path__ + "static/media/sww.f4b3c6cc.jpg";